import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

import bannerImage from "../assets/img/ban1.jpg";
import linkedin_icon from "../assets/img/skill-icons_linkedin.svg";
import instagram_icon from "../assets/img/skill-icons_instagram.svg";
import facebook_icon from "../assets/img/logos_facebook.svg";
import dummyimage from "../assets/img/dummyimage.png";

export default function PeopleProfilePage() {
  const { member_id } = useParams();
  const [showMore, setShowMore] = useState(false);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
 

  const toggleShowMore = () => setShowMore((prev) => !prev);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem("token");
        if (!token) {
          throw new Error("No authentication token found");
        }

        console.log("Fetching data for member_id:", member_id);

        const response = await axios.post(
          "http://localhost:5000/api/company/data",
          { member_id },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        console.log("Full API response:", JSON.stringify(response.data, null, 2));

        let userDetails = [];
        if (Array.isArray(response.data?.userDetails?.data)) {
          userDetails = response.data.userDetails.data;
        } else if (Array.isArray(response.data?.userDetails)) {
          userDetails = response.data.userDetails;
        } else if (response.data?.userDetails) {
          userDetails = [response.data.userDetails];
        } else {
          console.warn("Unexpected response structure:", response.data);
        }

        console.log("Processed userDetails:", userDetails);

        const matchedUser = userDetails.find(
          (user) => String(user?.member_id) === String(member_id)
        );

        if (matchedUser) {
          console.log("Matched user:", matchedUser);
          setUserData(matchedUser);
        } else {
          console.warn("No user found in response for member_id:", member_id);
          setError(`No user found with member_id: ${member_id}`);
          setUserData(null);
        }
      } catch (err) {
        console.error("API Error:", err.message, err.response?.data);
        setError(err.response?.data?.message || `Failed to fetch user data: ${err.message}`);
        setUserData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, [member_id]);

  // if (loading) return <div>Loading...</div>;
  // if (error) return <div>{error}</div>;
  // if (!userData) return <div>No Data Available</div>;

  const getUserField = (field) => {
    return userData[field] || "N/A";
  };

  return (
    <div id="wrapper">
      <section
        id="banner"
        style={{
          minHeight: "480px",
          background: `url(${bannerImage}) center left no-repeat`,
          backgroundSize: "cover",
        }}
        className="d-flex py-5 bg-dark text-white"
      >
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-7 mx-auto pt-5">
              <div className="text-center pt-5">
                
                {userData && (
                  <>
                  <h1 className="display-1 mb-3 fw-bold">
                    {getUserField("first_name")} {getUserField("last_name")}
                  </h1>
                  <h4 className="fw-normal lh-base">
                    {getUserField("job_title")}
                  </h4>
                  </>

                )}

              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="inner_section">
        <div className="container">

          {loading ? (
            <div className="dataloading ft-16 fw-600 text-center py-5">
              <i class="fa fa-spinner fa-spin white loadingicon"></i>
              {/* Loading content... */}
            </div>
            ) : error ? (
            <div className="text-danger text-center py-5 text-white ft-18">{error}</div>
            ) : !userData ? (
              <div className="text-center py-5">No Data Available</div>
            ) : (
            <div className="row">
              <div className="col-lg-4">
                <aside id="asidebar_inner" className="ft-15 lh-22">
                  <div className="first_box card_box">
                    <div className="user-info mb-0 d-flex gap-3 align-items-center">
                      <img src={dummyimage} alt="User" />
                      <div>
                        <div className="name">
                          {getUserField("first_name")} {getUserField("last_name")}
                        </div>
                        <div className="time">{getUserField("job_title")}</div>
                      </div>
                    </div>
                  </div>

                  <div className="card_box color-555">
                    <table className="table info-table">
                      <tbody>
                        <tr>
                          <td style={{ whiteSpace: "nowrap" }}>Company Name</td>
                          <td className="info-content">
                            {getUserField("company_name")}
                          </td>
                        </tr>
                        <tr>
                          <td>Industry</td>
                          <td className="info-content">
                            {getUserField("sector_and_industry")}
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <div className="divider"></div>
                    <h5 className="fw-bold mb-3">Social Media</h5>
                    <div className="d-flex gap-3">
                      <a
                        href={getUserField("linkedin_url") || "#"}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img src={linkedin_icon} width="18" alt="LinkedIn" />
                      </a>
                      <a href="#">
                        <img src={instagram_icon} width="18" alt="Instagram" />
                      </a>
                      <a href="#">
                        <img src={facebook_icon} width="18" alt="Facebook" />
                      </a>
                    </div>
                    <h5 className="ft-15 fw-700 mt-5 mb-3">Skills</h5>
                    <div className="skilltag">
                      <span className="stags">UX Research</span>
                      <span className="stags">Figma</span>
                      <span className="stags">Interaction Design</span>
                      <span className="stags">Usability Testing</span>
                      <span className="stags">Adobe XD</span>
                    </div>

                    <div className="divider"></div>
                    <h5 className="fw-bold mb-3">Company Insights</h5>
                    <table className="table info-table">
                      <tbody>
                        <tr>
                          <td>Company Size</td>
                          <td className="info-content">
                            {getUserField("employee_size")}
                          </td>
                        </tr>
                        <tr>
                          <td>Company Location</td>
                          <td className="info-content">
                            {getUserField("headquarter")}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {userData.company_url ? (
                              <a
                                href={userData.company_url}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: "blue" }}
                              >
                                {userData.company_url}
                              </a>
                            ) : (
                              "N/A"
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div className="divider"></div>
                    <h5 className="ft-15 fw-700 mb-3">Education</h5>
                    <table className="table info-table">
                      <tbody>
                        <tr>
                          <td className="info-title">
                            {getUserField("highest_education")}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </aside>
              </div>

              <div className="col-lg-8">
                <div className="inner_wrapper card_box py-5">
                  <ul className="nav nav-tabs nav-justified fw-bold border-0">
                    <li className="nav-item">
                      <a
                        className="nav-link active"
                        data-bs-toggle="tab"
                        href="#aboutpeople"
                      >
                        About
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className="nav-link"
                        data-bs-toggle="tab"
                        href="#WorkExperience"
                      >
                        Work Experience
                      </a>
                    </li>
                  </ul>

                  <div className="tab-content pt-3">
                    <div className="tab-pane fade show active" id="aboutpeople">
                      <div className="content">
                        <p>{getUserField("about_user")}</p>

                        <div className="contactinfo mt-5">
                          <h5 className="fw-bold">
                            <i className="bi bi-person me-2"></i> Contact
                            Information
                          </h5>
                          <div className="row mt-3 text-sm lh-base">
                            <div className="col-md-4 mb-3">
                              <div className="contact-box d-flex align-items-center gap-3">
                                <i className="bi bi-geo-alt"></i>
                                <span>
                                  {[
                                    getUserField("mailing_address"),
                                    getUserField("enter_city"),
                                    getUserField("state"),
                                    getUserField("country"),
                                  ]
                                    .filter((v) => v !== "N/A")
                                    .join(", ") || "N/A"}
                                </span>
                              </div>
                            </div>
                            <div className="col-md-4 mb-3">
                              <div className="contact-box d-flex align-items-center gap-3">
                                <i className="bi bi-telephone"></i>
                                <span>{getUserField("mobile")}</span>
                              </div>
                            </div>
                            <div className="col-md-4 mb-3">
                              <div className="contact-box d-flex align-items-center gap-3">
                                <i className="bi bi-envelope"></i>
                                <span>{getUserField("personal_email")}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="tab-pane fade" id="WorkExperience">
                      <div className="experience">
                        <div className="exp-header">
                          <div className="exp-info">
                            <h3>{getUserField("profession_type")}</h3>
                            <p>
                              {getUserField("company_name")} |{" "}
                              {getUserField("headquarter")}
                            </p>
                            <span>
                              {getUserField("work_experience_current_company")}
                            </span>
                            <div className="exp-content">
                              <p style={{ marginBottom: "1rem" }}>
                                <strong>1. Role Overview:</strong>
                                <br />
                                {getUserField("seniority_level")}
                              </p>
                              {showMore && (
                                <div>
                                  <p>
                                    <strong>2. Key Responsibilities:</strong>
                                    <br />
                                    {getUserField("job_responsibilities")}
                                  </p>
                                </div>
                              )}
                              <button
                                className="show-more-btn mt-3"
                                onClick={toggleShowMore}
                              >
                                {showMore ? "Show Less " : "Show More "}
                                <i
                                  className={`fa-solid ${
                                    showMore ? "fa-chevron-up" : "fa-chevron-down"
                                  }`}
                                ></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            )
          }
        </div>
      </section>
    </div>
  );
}